export default "__VITE_PUBLIC_ASSET__0976d8b0__"